import moment from 'moment'

export const formatedDate = (dateObject, format) => {
  if (!dateObject) {
    return ''
  }
  return moment(dateObject).format(format)
}

export const minToDateObj = (min) => {
  const nowMin = new Date().getTime() / (1000 * 60)
  return new Date((nowMin + min) * 60 * 1000)
}

export const getDiffInDays = (targetDate, referenceDate = null) => {
  const momentTargetDate = moment(targetDate).startOf('day')
  const momentReferenceDate = referenceDate ? moment(referenceDate).startOf('day') : moment.utc().startOf('day')
  const difference = momentTargetDate.diff(momentReferenceDate, 'days')

  return difference === 0 ? '' : difference
}

export const dateToMinutes = (date) => (parseInt((new Date(date).getTime() - new Date().getTime()) / (1000 * 60)))
